import {onMounted, onUnmounted} from 'vue'

export function useOrientationLock() {
    const lock = async () => {
        try {
            await screen.orientation.lock('portrait')
        } catch {
            // Silently fail in browsers that don't support (desktop, Safari). LandscapeBlock overlay handles this
        }
    }

    const unlock = () => {
        try {
            screen.orientation.unlock()
        } catch {
        }
    }

    onMounted(lock)
    onUnmounted(unlock)
}